import React from 'react';
import { PhoneIcon, MailIcon, ArrowRightIcon } from 'lucide-react';
export function ContactCTA() {
  return <section className="bg-[#1E3D2F] text-white py-24 px-6 relative overflow-hidden" data-id="element-1">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#C9B99A]/5 -skew-x-12 transform origin-top" data-id="element-2" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-3">
        <h2 className="text-3xl md:text-4xl mb-2" data-id="element-4">
          Interested in this property?
        </h2>
        <p className="text-[#C9B99A] text-lg mb-12 font-light" data-id="element-5">
          Contact the exclusive selling agent for a private inspection.
        </p>

        <div className="bg-[#F5F0E8] text-[#1E3D2F] p-8 md:p-12 max-w-2xl mx-auto shadow-2xl" data-id="element-6">
          <div className="flex flex-col items-center" data-id="element-7">
            <div className="w-24 h-24 bg-[#1E3D2F] rounded-full flex items-center justify-center text-3xl text-[#C9B99A] font-serif mb-6" data-id="element-8">
              DK
            </div>

            <h3 className="text-3xl font-serif mb-2" data-id="element-9">Dylan Kilner</h3>
            <p className="text-sm tracking-widest uppercase text-gray-500 mb-8 font-medium" data-id="element-10">
              Director / Licensed Estate Agent
            </p>

            <div className="w-full space-y-4" data-id="element-11">
              <a href="tel:0400000000" className="flex items-center justify-center w-full py-4 border border-[#1E3D2F] hover:bg-[#1E3D2F] hover:text-white transition-all duration-300 group" data-id="element-12">
                <PhoneIcon className="h-5 w-5 mr-3 group-hover:text-[#C9B99A] transition-colors" data-id="element-13" />
                <span className="font-medium" data-id="element-14">0400 000 000</span>
              </a>

              <a href="mailto:dylan.kilner@agency.com.au" className="flex items-center justify-center w-full py-4 bg-[#1E3D2F] text-white hover:bg-[#152b21] transition-all duration-300" data-id="element-15">
                <MailIcon className="h-5 w-5 mr-3 text-[#C9B99A]" data-id="element-16" />
                <span className="font-medium" data-id="element-17">Email Enquiry</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex justify-center space-x-8 text-sm text-white/40" data-id="element-18">
          <p data-id="element-19">*Approximate measurements</p>
          <p data-id="element-20">STCA: Subject to Council Approval</p>
        </div>
      </div>
    </section>;
}